import React from 'react';
import ReactDOM from 'react-dom';

define([
  "jquery",
  "globals",
  "knockout",
  "header-view-model",
  "../../../react/site-bdc/sharedPreviouslyViewedProducts/index",
  "select-element-content",
  "scroll-to-top",
  "accordion",
  "tabs",
  "sticky-kit",
  "internal-user-sticky",
  "unveil"],
function ($, globals, ko, HeaderViewModel, PreviouslyViewedProducts) {

  const initializeEmailSubscription = () => {
    import(/* webpackChunkName: "enews" */ '../../../../../javascript/_shared/components/Enews').then((module) => {
      const Enews = module.default;
      ReactDOM.render(<Enews />, document.getElementById('gcc-enews'));
    });
  };

  const initializeFooter = () => {
    import(/* webpackChunkName: "footer" */ '../../../../../javascript/bcom/header-footer/Footer').then((module) => {
      const { default: Footer } = module;
      const footer = new Footer();
      footer.getCECHours();
    });
  };

  $('#FooterLoaderImg').unveil(600, null, () => {
    const baseURL = `${window.location.protocol}//${window.location.host}/Home/GetPageSection?Requestedpage=`;
    const requestURL = document.querySelector('#FooterLoaderImg').dataset.lazyUrl;
    $.get(`${baseURL}${requestURL}`, (response) => {
      $('#FooterLoaderImg').after(response);
      initializeFooter();
      initializeEmailSubscription();
    });
  });

  let updateContentOffset = function() {
    let height;
    var globalBannerHeight = $('#gcc-global-banner').outerHeight() || 0;
    var topnavHeight = $('#gcc-header').outerHeight() || 0;
    var searchBarHeight = $('#gcc-header-search').outerHeight() || 0;
    var internalUserBarHeight = $('#internal-user-sticky').is(':visible') ? $('#internal-user-sticky').outerHeight() : 0;
    if (globals.breakpoint.value === 'small' || globals.breakpoint.value === 'medium') {
      height = (topnavHeight + searchBarHeight + globalBannerHeight + internalUserBarHeight);
    } else {
      height = (topnavHeight + globalBannerHeight + internalUserBarHeight);
    }
  }

  if ($('#bc-captive-header').length > 0) {
    var headerViewModel = new HeaderViewModel();
    var postMeasureCookie = Cookies.get('postMeasureOptions');
    if (postMeasureCookie) {
      var postMeasureOptions = JSON.parse(postMeasureCookie);
      if (postMeasureOptions) {
        var f = $("#gcc-inline-search-hidden").get(0);
        if (f && postMeasureOptions.PlpFilters) {
          f.value = postMeasureOptions.PlpFilters;
        }
      }
    }
  }

  if ($('#gcc-header').length > 0) {
    var headerViewModel = new HeaderViewModel();
    ko.applyBindings(headerViewModel, $("#gcc-header").get(0));
    updateContentOffset();
    window.addEventListener("resize", function(e) {
      updateContentOffset();
    });
    window.addEventListener("orientationchange", function() {
      updateContentOffset();
    });
  }

  if($('#gcc-prvprodmount').length > 0) {
    PreviouslyViewedProducts.default();
  }

  //For lazy loading listen to the custom event
  document.addEventListener('onPreviousProductsSectionLoad', function (e) {
    if ($('#gcc-prvprodmount').length > 0) {
      PreviouslyViewedProducts.default();
    }
  });

  const input = document.getElementById('gcc-typeahead-input');
  if (input) {
	  input.addEventListener('click', () => {
		if (!document.getElementById('gcc-typeahead').dataset.placeholder) {
		  import(/* webpackChunkName: "searchBar" */ '../../../../../javascript/bcom/header-footer/SearchBar/index').then((module) => {
			  module.default();
		  });
		}
	  });
  }

  import(/* webpackChunkName: "enews" */ '../../../../../javascript/bcom/modals').then((module) => {
    const Modals = module.default;
    ReactDOM.render(<Modals />, document.getElementById('bc-modals'));
  });

  $('img[data-src]').unveil();
});
